import React, { Component } from 'react';

import Defaults from '../../../shared/constants/defaults';
import FormSettings from '../../../shared/constants/form-settings';

import FormActions from '../../../shared/actions/form';
import TinyMCE from 'react-tinymce';

import ToggleSelectorComponent from '../../../../../../common/react/components/toggle-selector';
import UrlInputComponent from '../../../../../../common/react/components/url-input';
import SVGIcon from '../../../../../../common/react/components/svg-icon';

import classNames from 'classnames';

export default class ConfirmationPageSection extends Component {
	render() {
		let { activeTab, localization } = this.props;

		// TinyMCE resolves the path to tinymce.css in a relative way, so the context
		// needs to be setup for each component using it.  Ohhhh, TinyMCE....
		const tinyMCECssPathContext = '../../../';

		const tinyMCEConfig = {
			...Defaults.TINYMCE_CONFIG,
			toolbar_drawer: '',
			contextmenu: false
		};

		tinyMCEConfig.content_css = tinyMCEConfig.content_css.replace(':pathContext:', tinyMCECssPathContext);

		return (
			<section className='confirmation-page'>
				<h2>{localization.substitute('Thank you page')}</h2>

				<div className='destination'>
					<p className='note'>
						{localization.substitute('After form submission respondents are taken to:')}
					</p>
					<ToggleSelectorComponent options={[
						{
							label: localization.substitute('Thank you page'),
							id: 'confirmation_thank_you_page_radio',
							name: 'confirmation_destination_selector',
							value: 'thank_you_page',
							checked: activeTab === 'thank_you_page',
							callback: this.handleTabChange()
						},
						{
							label: localization.substitute('Custom Link'),
							id: 'confirmation_custom_link_radio',
							name: 'confirmation_destination_selector',
							value: 'custom_link',
							checked: activeTab === 'custom_link',
							callback: this.handleTabChange()
						}
					]} />
				</div>

				<div className={classNames({'hidden': activeTab !== 'thank_you_page'}, 'thank-you-page', 'tab') + " " + (this.props.formCollectsPayment ? 'cust-disb' : '')}>
					<label>{localization.substitute('Thank you page message')}</label>
					<TinyMCE
						content={localization.substitute(this.props.confirmationMessage)}
						config={tinyMCEConfig}
						onBlur={this.handleContentChange(FormSettings.CONFIRMATION_MESSAGE)}
					/>

					<h3>{localization.substitute('Allow respondents to:')}</h3>
					<input
						id='submit_another_response_checkbox'
						type='checkbox'
						className='forceEnable'
						value={this.props.showSubmitAnotherResponseLink}
						defaultChecked={this.props.showSubmitAnotherResponseLink}
						onClick={this.handleToggle(FormSettings.SHOW_SUBMIT_ANOTHER_RESPONSE_LINK)}
					></input>
					<label htmlFor='submit_another_response_checkbox'>{localization.substitute('submit another response')}</label>
					<br/>
                    <div
                        className={"tooltip-holder"}
                        data-tooltip={this.props.formCollectsPayment ? localization.substitute('Payment responses cannot be edited') : this.props.formCollectsSignature ? localization.substitute('Form responses with signature fields cannot be edited') : null}
                        data-tooltip-position='bottom'>
                        <input
                            id='edit_response_checkbox'
                            type='checkbox'
                            value={(this.props.formCollectsPayment || this.props.formCollectsSignature) ? false : this.props.showEditResponseLink}
                            disabled={(this.props.formCollectsPayment || this.props.formCollectsSignature)}
                            defaultChecked={(this.props.formCollectsPayment || this.props.formCollectsSignature) ? false : this.props.showEditResponseLink}
                            onClick={this.handleToggle(FormSettings.SHOW_EDIT_RESPONSE_LINK)}
                        ></input>
                        <label htmlFor='edit_response_checkbox'>{localization.substitute('edit their response')}</label>
                    </div>
					<br/>
					<input
						id='see_summary_checkbox'
						type='checkbox'
						disabled={this.props.formCollectsPayment}
						value={this.props.showResponseSummary}
						defaultChecked={this.props.showResponseSummary}
						onClick={this.handleToggle(FormSettings.SHOW_RESPONSE_SUMMARY)}
					></input>
					<label htmlFor='see_summary_checkbox'>{localization.substitute('see a summary of their response')}</label>
				</div>

				<div className={classNames({'hidden': activeTab !== 'custom_link'}, 'custom-link', 'tab')}>
					<div className='field'>
						<label htmlFor='custom_link_input'>
							Link to send respondents to *
						</label>
						<UrlInputComponent
							ref='confirmationLinkInput'
							reference='confirmationLinkInput'
							id='custom_link_input'
							defaultValue={this.props.confirmationLink}
							changeCallback={this.updateConfirmationLink}
							required={activeTab === 'custom_link'}
						/>
					</div>
				</div>

			</section>
		);
	}

	handleToggle = (propertyName) => {
		return (evt) => {
			FormActions.saveSetting(propertyName, evt.target.checked);
		}
	}

	handleContentChange = (propertyName) => {
		return (evt) => {
			const rteContent = evt.target.getContent();
			FormActions.saveSetting(propertyName, rteContent);
		}
	}

	updateConfirmationLink = (value) => {
		FormActions.saveSetting(FormSettings.CONFIRMATION_LINK, value);
	}

	handleTabChange = () => {
		return (activeTab) => {
			FormActions.saveSetting(FormSettings.CONFIRMATION_DESTINATION, activeTab);
		}
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/advanced-settings/components/sections/confirmation-page.js